import { ApolloError } from 'apollo-client';
import { IntlFormatters } from 'react-intl';

import {
  IErrorDialog,
  getAppleOrGooglePayError,
  getErrorDialogForGraphQLCode,
  parseGraphQLErrorCodes
} from 'utils/errors';
import { GraphQLError } from 'utils/network';

interface IGetErrorDialogOptions {
  error: ApolloError | GraphQLError;
  formatMessage: IntlFormatters['formatMessage'];
  body: React.ReactNode;
  errorMsgId: string;
}

export const ORDER_FAILURE_MESSAGE_KEY = 'orderFailureMessage';
export const CONTACT_US_ROUTE_KEY = 'contact-us';

interface IErrorDialogOptions {
  body: React.ReactNode;
  error: ApolloError | GraphQLError;
  title: string;
  message: string;
}

export const getErrorDialogOptions = ({
  body,
  error,
  formatMessage,
  errorMsgId
}: IGetErrorDialogOptions): IErrorDialog | IErrorDialogOptions => {
  const [errorCode] = parseGraphQLErrorCodes(error);
  const errorDialog = errorCode && getErrorDialogForGraphQLCode(errorCode, formatMessage);

  if (errorDialog) {
    return { ...errorDialog, error };
  }

  return {
    body,
    error,
    message: formatMessage({ id: errorMsgId }),
    title: formatMessage({ id: 'uhoh' })
  };
};

export const getOrderFailureMessageKey = (fdAccountId: string) =>
  getAppleOrGooglePayError(fdAccountId, ORDER_FAILURE_MESSAGE_KEY);
